<!-- input-file-component.html -->
<div class="file-upload">
  <!-- LEFT BUTTON -->
  <ix-button class="doc-btn" (click)="triggerFileInput(fileInput)">{{ label }} </ix-button>

  <input
    #fileInput
    type="file"
    [accept]="accept"
    [attr.multiple]="allowMultiple ? '' : null"
    hidden
    (change)="onFileSelected($event)"
  />

  <!-- RIGHT DROP AREA -->
  <div class="drop-zone" [class.dragging]="isDragging">
    @if (!files.length) {
    <span>Drag & drop file here or click button</span>
    } @if (files.length) {
    <div class="file-details" *ngFor="let file of files">
      <strong>{{ file.name }}</strong>
      <ix-icon-button
        icon="trashcan"
        class="action-item icon-trash"
        variant="danger"
        (click)="removeFile(file)"
      ></ix-icon-button>
    </div>
    }
  </div>
</div>

@if (validationError) {
<div class="file-type-error">{{ validationError }}</div>
}
